import { render } from "./ProductFilters.vue?vue&type=template&id=a6fb1bec&scoped=true"
import script from "./ProductFilters.vue?vue&type=script&lang=js"
export * from "./ProductFilters.vue?vue&type=script&lang=js"

import "./ProductFilters.vue?vue&type=style&index=0&id=a6fb1bec&scoped=true&lang=css"

import exportComponent from "/home/forge/backoffice.callmewine.co.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6fb1bec"]])

export default __exports__